import {AutogenLayoutSmsFieldsContainer} from "./autogen/AutogenLayoutSmsFieldsContainer";
import {BlurEvent, ChangeEvent, LayoutProps, Snackbar } from "@mcleod/components";
import {Api, StringUtil} from "@mcleod/core";

interface SmsFieldsContainerLayoutProps extends LayoutProps {
    orderId: string;
}

export class SmsFieldsContainer extends AutogenLayoutSmsFieldsContainer {
    _orderId: string;

    constructor(props?: Partial<SmsFieldsContainerLayoutProps>) {
        super(props);
        if(props?.orderId !== undefined) {
            this._orderId = props?.orderId;
        }
    }
    async textboxSendMessageDeliveryModeOnChange(event: ChangeEvent) {
        const textboxDeliveryMode = this.textboxSendMessageDeliveryMode.text;
        if (StringUtil.equalsIgnoreCase("Prior to pickup", textboxDeliveryMode)) {
            if(this._orderId !== undefined) {
                await Api.post("lme/powerbroker/validate-origin-stop", {
                    order_id: this._orderId
                }).then(response => {
                    if(!response?.data?.[0]?.origin_arrival_time_passed) {
                        this.textboxHours.visible = true;
                        this.textboxHours.caption = "Hours Prior to Pickup";
                        this.textboxResendFrequency.visible = true;
                        this.textboxHours.required = true;
                    }else{
                        Snackbar.showWarningSnackbar("The pick-up time has passed.",{  id: "pickupTimeError"});
                        this.textboxSendMessageDeliveryMode.text = event.oldValue;

                    }
                });
            }
        } else if (StringUtil.equalsIgnoreCase("After pickup", textboxDeliveryMode)) {
            this.textboxHours.visible = true;
            this.textboxHours.caption = "Hours After Pickup";
            this.textboxResendFrequency.visible = true;
            this.textboxHours.required = true;

        } else {
            this.textboxHours.visible = false;
            this.textboxResendFrequency.visible = false;
            this.textboxRecurrenceTermination.visible = false;
            this.textboxHours.required = false;
        }
    }

    textboxHoursOnKeyUp(event: KeyboardEvent) {
        const hours = this.textboxHours.text;
        if (hours < "1") {
            this.textboxResendFrequency.visible = false;
            this.textboxRecurrenceTermination.visible = false;
        } else {
            this.textboxResendFrequency.visible = true;
        }
    }

    texboxHoursOnChange(event: BlurEvent) {
        const hours = this.textboxHours.text;
        if(hours < "1"){
            this.textboxResendFrequency.visible = false;
            this.textboxRecurrenceTermination.visible = false;
        }
    }

    textboxResendFrequencyOnChange(event: ChangeEvent){
        const hours = this.textboxResendFrequency.text;
        this.updateRecurrenceTermination(hours);
    }

    textboxResendFrequencyOnKeyUp(event: KeyboardEvent) {
        const hours = this.textboxResendFrequency.text;
        this.updateRecurrenceTermination(hours);
    }

    textboxResendFrequencyOnBlur(event: BlurEvent) {
        const hours = this.textboxResendFrequency.text;
        this.updateRecurrenceTermination(hours);

    }

    updateRecurrenceTermination(hours: string) {
        if (hours < "1") {
            this.textboxRecurrenceTermination.visible = false;
            this.textboxRecurrenceTermination.required = false;
        } else {
            this.textboxRecurrenceTermination.visible = true;
            this.textboxRecurrenceTermination.required = true;
        }
    }
}
